module.exports = __webpack_public_path__ + "assets/img/33_1563.cca9c3ae.jpg";